/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentFund
 */
export interface InvestmentFund {
    /**
     * 
     * @type {string}
     * @memberof InvestmentFund
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFund
     */
    fundMarketValue: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFund
     */
    fundPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFund
     */
    unitPrice: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentFund
     */
    unitPriceDate: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFund
     */
    unitsBought: number;
}

/**
 * Check if a given object implements the InvestmentFund interface.
 */
export function instanceOfInvestmentFund(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;
    isInstance = isInstance && "fundMarketValue" in value;
    isInstance = isInstance && "fundPercentage" in value;
    isInstance = isInstance && "unitPrice" in value;
    isInstance = isInstance && "unitPriceDate" in value;
    isInstance = isInstance && "unitsBought" in value;

    return isInstance;
}

export function InvestmentFundFromJSON(json: any): InvestmentFund {
    return InvestmentFundFromJSONTyped(json, false);
}

export function InvestmentFundFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentFund {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundName': json['FundName'],
        'fundMarketValue': json['FundMarketValue'],
        'fundPercentage': json['FundPercentage'],
        'unitPrice': json['UnitPrice'],
        'unitPriceDate': (new Date(json['UnitPriceDate'])),
        'unitsBought': json['UnitsBought'],
    };
}

export function InvestmentFundToJSON(value?: InvestmentFund | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundName': value.fundName,
        'FundMarketValue': value.fundMarketValue,
        'FundPercentage': value.fundPercentage,
        'UnitPrice': value.unitPrice,
        'UnitPriceDate': (value.unitPriceDate.toISOString()),
        'UnitsBought': value.unitsBought,
    };
}

